import { Field } from "../../models/field.model";
export class FormDatatableComponent extends Field {
    constructor() {
        super(...arguments);
        // Noetig um ueber properties eines Objekts zu iterieren
        this.objectKeys = Object.keys;
    }
}
